import { server } from '@/helpers';

export function getPopularAndSimilar(placeId: string) {
  return server.request
    .get(`/search/similar-popular/${placeId}`)
    .then(server.handleSuccess)
    .catch(server.handleErrorObject);
}
